// src/modules/IntegratedMessaging/adapters/TeamsApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import { Team } from '../hooks/useTeams';

export class TeamsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Devuelve la lista de teams disponibles (teams-child)
   */
  async getTeams(): Promise<Team[]> {
    const response = await this.httpClient.get<{ data: Team[] } | Team[]>(
      '/teams-child'
    );
    // Manejar tanto array directo como objeto con data
    return Array.isArray(response) ? response : response.data || [];
  }
}
